// Helpers de rol compartidos por el shell del Dashboard y sus vistas.
// Mantienen el comportamiento existente; no cambian la matriz de permisos.

const ADMIN_ROLES = new Set([
  'super_admin',
  'admin_marca',
  'admin_gym_virtual',
  'admin_gimnasio',
  'admin_gym',
  'admin_sede',
  'admin_d28d',
  'admin_food_plan',
  'admin_food',
  'admin_training',
  'admin_entrenador',
  'entrenador',
  'entrenador_d28d',
  'entrenador_gym',
  'nutricionista',
]);

/** Alineado con backend accessControl.normalizeRoles: fusiona rol primario + roles[]. */
export function userRoles(user) {
  const primary = user?.rol || 'usuario_final';
  const extra = Array.isArray(user?.roles) ? user.roles : [];
  return [...new Set([primary, ...extra].filter(Boolean))];
}

export function isFinalUser(user) {
  const roles = userRoles(user);
  if (roles.length === 0) return true;
  return !roles.some((r) => ADMIN_ROLES.has(r));
}

export function defaultViewForRole(user) {
  if (isFinalUser(user)) return 'myplan';
  const roles = userRoles(user);
  if (roles.includes('entrenador_gym') && !roles.includes('entrenador')) return 'liveclasses';
  if (roles.includes('entrenador_d28d') && !roles.includes('entrenador')) return 'liveclasses';
  if (roles.includes('entrenador')) return 'coach';
  if (roles.some((r) => ['admin_gimnasio', 'admin_gym', 'admin_gym_virtual', 'admin_marca', 'admin_sede'].includes(r))) return 'gymadmin';
  return 'home';
}

export function makeHasAnyRole(roles) {
  return (list) => list.some((r) => roles.includes(r));
}

/** Coach operador FOOD (panel /trainer): sin compra ni validación de plan consumidor. */
export function isCoachFoodOperator(user) {
  const roles = userRoles(user);
  return roles.some((r) => ['entrenador', 'nutricionista', 'admin_training', 'admin_entrenador'].includes(r));
}
